import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = { tenantId: String }

    connect() {
        // This runs when the controller connects to the DOM
        console.log("Google auth controller connected")
    }

    open() {
        const popup = window.open(
            `/admin/auth/google/${this.tenantIdValue}`,
            'google-auth',
            'width=500,height=600,scrollbars=yes,resizable=yes'
        );
    }

    showTurboFlash(message, type) {
        fetch('/flash', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
                'Accept': 'text/vnd.turbo-stream.html'
            },
            body: JSON.stringify({
                message: message,
                type: type
            })
        })
            .then(response => response.text())
            .then(turboStreamHtml => {
                Turbo.renderStreamMessage(turboStreamHtml);
            })
            .catch(error => {
                console.error('Error showing flash message:', error);
            });
    }
}
